var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs-items',{model:{value:(_vm.getCurrentTicketTab),callback:function ($$v) {_vm.getCurrentTicketTab=$$v},expression:"getCurrentTicketTab"}},[_c('v-tab-item',[_c('PropsPage')],1),_c('v-tab-item',[_c('AppSettings')],1),_c('v-tab-item',[_c('AccountSettings')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }